var app = angular.module('storefrontApp');
app.controller('topPicksController',
    ['$rootScope', '$scope', 'elasticService', "randomService",
    function ($rootScope, $scope, elasticService, randomService) {

        $scope.size = 100;
        $scope.topPicksPool = [];
        $scope.requiredSize = 40;
        $scope.matchPercent = 70;
        $scope.definitionNames = [];
        $scope.viewedProductInfo = [];

        $scope.getShippableProducts = function () {
            elasticService.getElasticData(elasticService.buildShippableProductsRequest()).then(
                function (response) {
                    $scope.topPicksPool = $scope.topPicksPool.concat(response.data.hits.hits);
                    $scope.topPicks = randomService.getRandomItemsfromListArray($scope.topPicksPool);
                }
            );
        }

        $scope.sendGAEvent = function(key, page) {
            if (typeof gtag !== 'undefined') {
                gtag('event', page, {
                    'event_category': 'engagement',
                    'event_action': key
                });
            }
        }

        function getDefaultTopPicks(){
            var topItemsList = new Array(6).fill(null);
            Promise.all([
                elasticService.getElasticData(elasticService.buildDefaultStockDesignsRequest()).then(function (response){
                    if (response && response.data && 'aggregations' in response.data) {
                        var responseData = response.data.aggregations.definitions.buckets;
                        var designProducts =[]
                        angular.forEach(responseData, function (bucket) {
                            designProducts = randomService.getRandomItemsfromListArray(bucket.topByDefinitions.hits.hits,3);
                        });
                        topItemsList[0] = designProducts[0];
                        topItemsList[3] = designProducts[1];
                        topItemsList[5] = designProducts[2];
                    }
                }),
                elasticService.getElasticData(elasticService.buildDefaultOtherProductsRequest()).then(function (response) {
                    if (response && response.data) {
                        var fonts = randomService.getRandomItemsfromListArray(response.data.hits.hits,1);
                        topItemsList[1] = fonts[0];
                    }
                }),
                elasticService.getElasticData(elasticService.buildShippableProductsRequest()).then(function (response) {
                    if (response && response.data) {
                        var shippableProducts = randomService.getRandomItemsfromListArray(response.data.hits.hits,1);
                        topItemsList[2] = shippableProducts[0];
                    }
                }),
                elasticService.getElasticData(elasticService.buildPDFPatternsProductsRequest()).then(function (response) {
                    if (response && response.data) {
                        var patterns = randomService.getRandomItemsfromListArray(response.data.hits.hits,1);
                        topItemsList[4] = patterns[0];
                    }
                })
            ]).then(function () {
                $scope.topPicks = topItemsList;
            })
        }

        $scope.getTopPicks = function(prdId){
            var productIds = [];
            if(angular.isDefined(prdId) && prdId.length > 0){
                $scope.isProductPage = true;
                $scope.$watch(function() {
                    return $rootScope.isPatchEligible;
                }, function(newValue) {
                        productIds.push(prdId);
                        getRelatedProductInfo(productIds);
                });    
          
            }
            else{
                var recentlyViewed = localStorage.getItem("recentlyViewed");
                if(angular.isDefined($rootScope.customerCartRS) && $rootScope.customerCartRS.length > 0 && $rootScope.isCartPage){
                    productIds = $rootScope.customerCartRS.filter(
                                    function(productId) {
                                        productId = productId.toLowerCase();
                                        return !(productId.startsWith("empt01-") || productId === "gc" || productId === "cd" || productId.startsWith("ed-"));
                                    }
                                );

                    if(productIds.length > 0){
                        $scope.matchPercent = 10;
                        $scope.loadShippables = true;
                        getRelatedProductInfo(productIds);
                    }
                    else{
                        getDefaultTopPicks();
                    }
                }
                else if(recentlyViewed && recentlyViewed.length > 1){
                    if(!(angular.isUndefined(recentlyViewed) && recentlyViewed !== null)){
                        angular.forEach(recentlyViewed.split(','), function(product){
                            productIds.push(product);
                        });
                    }
                    getRelatedProductInfo(productIds);
                }
                else {
                    getDefaultTopPicks();
                }
            }
        }

        function getRelatedProductInfo(productIds){
            elasticService.getElasticData(elasticService.buildProductByIdsRequest(angular.toJson(productIds))).then(
                function (response) {
                    if (response) {
                        angular.forEach(response.data.hits.hits, function (res) {
                            if($scope.definitionNames.indexOf(res._source.definitionName) < 0){
                                if(angular.isDefined(res._source.definitionName))
                                {
                                    $scope.definitionNames.push(res._source.definitionName);
                                }
                            }
                        });
                        $scope.viewedProductInfo = response.data.hits.hits;
                        if($scope.viewedProductInfo.length > 0){
                            $scope.getRelatedProducts($scope.viewedProductInfo);
                        }
                        else{
                            getDefaultTopPicks();
                        }
                    }
                }
            );
        }

        $scope.getRelatedProducts = function (products) {
            elasticService.getElasticData(buildRequest(products)).then(
                function(response){
                    if(response && 'aggregations' in response.data){
                        $scope.count = response.data.hits.total.value;
                        var data = response.data.aggregations.definitions.buckets;
                        if($scope.isProductPage){
                            $scope.requiredSize = 4;
                        }
                        if ($scope.count <= $scope.requiredSize && $scope.matchPercent > 10) {
                            $scope.matchPercent = $scope.matchPercent - 10;
                            $scope.getRelatedProducts($scope.viewedProductInfo );
                        }
                        else if ($scope.count <= $scope.requiredSize && $scope.matchPercent == 10) {
                            angular.forEach(data, function(d){
                                $scope.topPicksPool = $scope.topPicksPool.concat(d.topByDefinitions.hits.hits);
                            });
                            if($scope.isProductPage && $scope.topPicksPool.length > 3){
                                $scope.topPicks = randomService.getRandomItemsfromListArray($scope.topPicksPool);
                            }
                            else{
                                getRecentlyViewedFillers();
                            }
                        }
                        else{
                            angular.forEach(data, function(d){
                                $scope.topPicksPool = $scope.topPicksPool.concat(d.topByDefinitions.hits.hits);
                            });
                            if($scope.loadShippables){
                                $scope.getShippableProducts();
                            }
                            else{
                                $scope.topPicks = randomService.getRandomItemsfromListArray($scope.topPicksPool);
                            }
                        }
                    }
                }
            )
        }

        function buildRequest(result) {
            var EXCLUDED_FIELDS = [
                "*.productTabContent",
                "*.mainFeatures",
                "variants.associatedItemsList",
                "variants.associatedItems",
                "categories",
                "categoriesList",
                "variants.fTA",
                "designKeywords",
                "keywords",
                "colorSequence",
                "variants.fileTypesAvailable"
            ];

            var moreLikeThis = {
                fields: ["keywords", "name"],
                like: [],
                min_term_freq: 1,
                min_doc_freq: 5,
                max_query_terms: 100,
                minimum_should_match: $scope.matchPercent + "%"
            };

            var filters = [
                { range: { listPrice: { gt: 1.99 } } },
                { term: { inStock: true } }
            ];
            if ($rootScope.isPatchEligible) {
                filters.push({ term: { "variants.isPatchEligible": true } });
            }

            var shouldDefinitions = [];
            angular.forEach($scope.definitionNames, function (def) {
                if (def.toLowerCase() === "font") {
                    var fontTypeMatches = [];
                    angular.forEach(result, function (doc) {
                        if (doc._source.definitionName.toLowerCase() === "font") {
                            fontTypeMatches.push({ term: { fontType: doc._source.fontType } });
                        }
                    });
                    shouldDefinitions.push({
                        bool: {
                            must: [
                                { term: { definitionName: def } },
                                { bool: { should: fontTypeMatches } }
                            ]
                        }
                    });
                } else {
                    shouldDefinitions.push({ term:{ "definitionName": def }});
                }
            });

            angular.forEach(result, function (doc) {
                moreLikeThis.like.push({ _id: doc._id });
            });

            var request = {
                track_total_hits: true,
                sort: [
                    { rating: "desc" },
                    { saleRank: "desc" }
                ],
                _source: { excludes: EXCLUDED_FIELDS },
                query: {
                    function_score: {
                        query: {
                            bool: {
                                must: { more_like_this: moreLikeThis },
                                filter: {
                                    bool: {
                                        must: [
                                            { bool: { should: shouldDefinitions } }
                                        ].concat(filters)
                                    }
                                }
                            }
                        },
                        functions: [
                            {
                                field_value_factor: {
                                    field: "saleRank",
                                    factor: 1.5,
                                    modifier: "sqrt",
                                    missing: 0
                                }
                            }
                        ],
                        boost_mode: "sum"
                    }
                },
                size: 0,
                aggs: {
                    definitions: {
                        terms: { field: "definitionName"},
                        aggs: {
                            topByDefinitions: {
                                top_hits: {
                                    size: $scope.size,
                                    _source: { excludes: EXCLUDED_FIELDS }
                                }
                            }
                        }
                    }
                }
            };
            return angular.toJson(request);
        }

        function getRecentlyViewedFillers(){
            var matchedTopPicks = [];
            var filteredFillerResults = [];
            elasticService.getElasticData(elasticService.buildRecentlyViewedFillers($scope.definitionNames,$scope.requiredSize)).then(
                function (response) {
                    if (response && response.data) {
                        var fillerResults = response.data.hits.hits;
                        var topPicksPoolIds = new Set($scope.topPicksPool.map(function(pick){ pick._id}));
                        angular.forEach(fillerResults, function(fillerItem) {
                            if (!topPicksPoolIds.has(fillerItem._id)) {
                                filteredFillerResults.push(fillerItem);
                            }
                        });

                        if($scope.topPicksPool.length > ($scope.requiredSize / 2 - 5)){
                            matchedTopPicks = randomService.getRandomItemsfromListArray($scope.topPicksPool,3);
                            fillerTopPicks = randomService.getRandomItemsfromListArray(filteredFillerResults,3);
                            $scope.topPicks = matchedTopPicks.concat(fillerTopPicks);
                        }
                        else{
                            var fillerPicksPool = $scope.topPicksPool.concat(filteredFillerResults);
                            $scope.topPicks = randomService.getRandomItemsfromListArray(fillerPicksPool);
                        }
                    }
                }
            );
        }
    }
]);
